import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute, NavigationEnd, ParamMap, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Supplier } from "src/app/inventory/supplier/supplier";
import { Page } from "src/app/util/page";
import { Criteria } from "src/app/util/search/criteria/criteria";
import { FrCriteria } from "src/app/util/search/criteria/fr-criteria";
import { SearchComponent } from "src/app/util/search/search-component";
import { SearchRequest } from "src/app/util/search/search-request";
import { PurchaseOrderSearchResult } from "../purchase-order-search-result";
import { PurchaseOrderService } from "../purchase-order.service";
import { SupplierSearchCriteriaComponent } from "./criteria/supplier-search-criteria.component";
import { NewPurchaseOrderComponent } from "./new-purchase-order/new-purchase-order.component";

@Component({
  templateUrl: './purchase-order-search.component.html'
})
export class PurchaseOrderSearchComponent extends SearchComponent<PurchaseOrderSearchResult> {
  public loading = false;
  public error = false;

  @ViewChild(SupplierSearchCriteriaComponent)
  supplierCriteria!: SupplierSearchCriteriaComponent;

  constructor(
    private modalService: NgbModal,
    private purchaseOrderService: PurchaseOrderService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    super(new Map<string, Criteria>([
      ["supplier", new FrCriteria("Le fournisseur")]
    ]));
  }

  public addSupplierFilter(publisher: string) {
    this.addFilter("supplier", publisher);
  }

  public clearSupplier() {
    this.clearFilter("supplier");
  }

  public confirmNewPurchaseOrder(supplier: Supplier) {
    this.purchaseOrderService.create(supplier.id)

      .subscribe({
        next: purchaseOrder => this.router.navigate(["/purchase/order", purchaseOrder.number]),
        error: e => {
          this.loading = false;
          this.error = true;
        }
      });
  }

  public displaySupplierFilter(): string {
    return this.displayFilter("supplier");
  }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
      }
    });
  }

  ngAfterViewInit(): void {
    this.supplierCriteria.onFilterAdded().pipe(tap(supplier => this.addSupplierFilter(supplier))).subscribe();

    this.route.queryParamMap.subscribe(queryParam => setTimeout(() => this.searchWithQueryParam(queryParam)));
  }

  public onSearch(searchRequest: SearchRequest, page: number): Observable<Page<PurchaseOrderSearchResult>> {
    var searchPurchaseOrderRequest = {
      query: searchRequest.query,
      supplier: searchRequest.getValues("supplier"),
    };

    return this.purchaseOrderService.search(searchPurchaseOrderRequest, page, 20);
  }

  public openPurchaseOrder(purchaseOrder: PurchaseOrderSearchResult) {
    this.router.navigateByUrl("/purchase/order/" + purchaseOrder.number);
  }

  public openSearchSupplierModal() {
    var modalRef = this.modalService.open(NewPurchaseOrderComponent);

    modalRef.componentInstance.onConfirm = (supplier: Supplier) => this.confirmNewPurchaseOrder(supplier);
    modalRef.componentInstance.applyButtonTitle = "Créer une commande";
  }

  public refresh() {
    this.router.navigate(["/purchase/order"], { queryParams: this.getQueryParams() });
  }

  public searchWithQueryParam(paramMap: ParamMap) {
    this.initWithParamMap(paramMap);

    this.search();
  }
}